
import { Component, Vue } from 'vue-property-decorator'
import BackNav from '@/components/BackNav/index.vue'
import { editStoreInfo } from '@/api/store'
import { Debounce } from '@/core/decorator'
import { Getter, Action } from 'vuex-class'

@Component({
  name: 'EditStoreName',
})
export default class EditStoreName extends Vue {
  @Getter companyId!: string
  @Getter info!: any
  @Action GetInfo!: (info: any) => void
  storeName = ''

  isShake = false
  errShakeClass = 'animate__animated animate__headShake'
  isExceed = false

  created() {
    // 从路由参数获取初始值
    this.storeName = (this.$route.query.name as string) || '鲜萃元气养胃精品生鲜店'
  }

  mounted() {
    this.$nextTick(() => {
      const inputField = this.$refs.inputField as any
      if (inputField && inputField.$el) {
        const textarea = inputField.$el.querySelector('input')
        if (textarea) {
          textarea.focus()
        }
      }
    })
  }

  getWeightedLength(val: string) {
    if (!val) return 0
    return Array.from(val).reduce((count, char) => {
      return count + (/[\u4e00-\u9fa5]/.test(char) ? 2 : 1)
    }, 0)
  }

  @Debounce(500)
  async onSave() {
    if (this.getWeightedLength(this.storeName) > 30 || !this.storeName.trim()) {
      this.isShake = true
      this.isExceed = true
      setTimeout(() => {
        this.isShake = false
        this.isExceed = false
      }, 1000)
      return
    }
    try {
      const res = await editStoreInfo({
        storeId: this.companyId,
        storeName: this.storeName
      })
      if (res.code === '000000') {
        this.$toast.success('保存成功')
        this.GetInfo({ ...this.info, storeName: this.storeName })
        setTimeout(() => {
          this.$router.back()
        }, 1000)
      } else {
        this.$toast.fail(res.msg || '保存失败')
      }
    } catch (e) {
      console.error(e)
      this.$toast.fail('保存失败')
    }
  }
}
